import React from "react";
import { Link } from "react-router-dom";
import data from "./data.json";
import logo from "./assets/logo.png";
import "./HomePage.css";

const HomePage = () => {
  // Crea una copia e ordina per "nome cognome" in ordine alfabetico
  const sortedData = data.slice().sort((a, b) => {
    const nameA = (a.name + " " + a.surname).toLowerCase();
    const nameB = (b.name + " " + b.surname).toLowerCase();
    return nameA.localeCompare(nameB);
  });

  return (
    <div className="home-page">
      <header className="home-header">
        <img src={logo} alt="Logo" className="home-logo" />
      </header>
      <h1 className="home-title">Biglietti da Visita</h1>
      <div className="card-grid">
        {sortedData.map((person) => (
          <Link key={person.slug} to={`/${person.slug}`} className="card-link">
            <div className="card">
              <h2 className="card-name">
                {person.name}
                <br />
                {person.surname}
              </h2>
              <p className="card-role">{person.role}</p>
              {/*
              I campi telefono ed email sono stati commentati come da componente fornito
              */}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default HomePage;
